<div class="alarmPage">
  <div class="alarm-container">
      <div class="custom-container">
        <mat-card class="alarm-card">
          <mat-card-content>
            <h1>Control de Alarmas</h1>
            <alarm-table
              [columnHeader]="columnHeader"
              [catalogPaginationRequest]="catalogPaginationRequest"
            >
            </alarm-table>
          </mat-card-content>
        </mat-card>
      </div>
  </div>
</div>